import { memo } from 'react'
import { Checkbox, FormControlLabel } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { useIntl } from 'react-intl'
import { setSendInvitation, useImportCSVData } from 'app/store/importCSV'

import useStyles from './styles'

const CheckboxSendInvitation = () => {
  const dispatch = useDispatch()
  const { formatMessage } = useIntl()

  const {
    data: { sendInvitation },
  } = useImportCSVData()

  const classes = useStyles()

  const handleOnChangeSendInvitation = (e) => {
    const { checked } = e.target
    dispatch(setSendInvitation(checked))
  }

  return (
    <FormControlLabel
      className={classes.formControlLabel}
      control={
        <Checkbox
          className={classes.root}
          checked={sendInvitation}
          onChange={handleOnChangeSendInvitation}
          disableRipple
        />
      }
      label={formatMessage({
        id: 'subscribers.import.checkboxSendInvitation.label',
      })}
    />
  )
}

export default memo(CheckboxSendInvitation)
